export default __webpack_public_path__ + "static/media/2026-06-10-11-42-29-001_Otra Vida Tattoo Piercing Stuttgart-youtube.ac97a2a6.mp4";